import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ui from '../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-regular-svg-icons';

const List = ({ t, ...rest }) => {

	const renderWeeks = (weeks) => {
		return (
			<div>
				{weeks.map(w =>
					<Link to={`/workshopAttendance/workshop/${w.workshopId}/week/${w.id}`} className='btn btn-teal' style={{ marginRight: '5px', marginBottom:'1px' }}>
						{w.name}
					</Link>)}
			</div>
		);
	}

	const columns = [
		{
			header: t('Workshop_Name'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('Workshop_StartDate'),
			accessor: 'startDate',
			cell: (startDate) => (ui.formatDate(startDate))
		},
		{
			header: t('Workshop_EndDate'),
			accessor: 'endDate',
			cell: (endDate) => (ui.formatDate(endDate))
		},
		{
			header: t('Workshop_Weeks'),
			accessor: 'weeks',
			cell: (weeks) => renderWeeks(weeks)
		}
	];

	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faCalendarDays} /> {t('Workshop_AttendanceInfo')}</Panel.Heading>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default List;